// extracted by mini-css-extract-plugin
module.exports = {"component":"PodcastsButton_component__l9v0n"};